module.exports = __webpack_public_path__ + "assets/img/InstitutionalA.9f8ea667.png";